import React from 'react'
import { Routes, Route } from "react-router-dom";
import Menu from './Menu'
import ReportRegistration from './ReportRegistration';
import Authentication from '../../Func/Authentication';
import Report from './Report';
import HealthInsurance from './HealthInsurance';
import ReportOrderShirt from './ReportOrderShirt';
import ReportWelfareShirt from './ReportWelfareShirt';
import TrainingManagement from './TrainingManagement';

const Home = () => {

    const [token] = React.useState(localStorage.getItem("token"));
    const iden = Authentication(token)

    if (!token) {
        window.location = '/Login'
        return null; // ป้องกันการ render content ก่อน redirect
    }

    return (
        <div className="">
            {/* ส่วนหัวเมนูที่เราปรับให้สวยงามแล้ว */}
            <Menu iden={iden} />

            {/* ส่วนเนื้อหาหลัก (Main Content Area) */}
            <main className="flex-grow">
                <div>
                    {/* ห่อหุ้ม Routes ด้วย Animation-friendly div */}
                    <div className="animate-fadeIn">
                        <Routes>
                            <Route path="/*" element={<Report />} />
                            <Route path="/report/registration/*" element={<ReportRegistration />} />
                            <Route path="/Health-insurance/*" element={<HealthInsurance />} />
                            <Route path="/report/Order-a-Shirt/*" element={<ReportOrderShirt />} />
                            <Route path="/report/Welfare-Shirt/*" element={<ReportWelfareShirt />} />
                            <Route path="/training-management/*" element={<TrainingManagement />} />
                        </Routes>
                    </div>
                </div>
            </main>

            {/* เพิ่ม CSS พื้นฐานสำหรับ Animation (สามารถย้ายไปไว้ใน index.css ได้) */}
            <style dangerouslySetInnerHTML={{ __html: `
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fadeIn {
                    animation: fadeIn 0.4s ease-out forwards;
                }
            `}} />
        </div>
    )
}

export default Home